import { useState } from "react";
import SideBar from "../../Common/SideBar";
import { useSelector } from "react-redux";
import BreadCrumbsContainer from "../../Common/Breadcrumbs";
import { Outlet } from "react-router-dom";

const ProductScreen = () => {
  const sidebar = useSelector(state => state.sidebar);
  const [addProductPage, setAddProductPage] = useState(false);
  return (
    <div className="dashboardOuterContainer">
      {/* <SideBar /> */}
      <div
        className={`${
          sidebar.expand
            ? "dashboardInnerSidebarBig"
            : "dashboardInnerSidebarSmall"
        }`}>
        <div className="dashboardDataCardContainer no-scrollbar">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ProductScreen;
